export enum CopilotActionType {
	LOGIN = 'LOGIN',
	REGISTER = 'REGISTER'
}
